import * as React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import './style.scss';

interface NavigationSecondaryMenuItemProps {
  item: ImmutableEntity<any>,
}

const NavigationSecondaryMenuItem: React.FC<NavigationSecondaryMenuItemProps> = ({ item }) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);

  const title = item.getIn(['link', 'title'], 'Untitled');
  const url = item.getIn(['link', 'url'], '');
  const subTree = item.get('subtree');

  return (
    <li
      key={title}
      className="secondary-navigation__itemWrapper"
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      <div className="secondary-navigation__item">
        <CoreLink className="secondary-navigation__item__link" to={url}>{title}</CoreLink>
        {subTree.size > 0 && (
          <button
            type="button"
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
            className="icon icon-chevron-right"
          >
            Expand menu
          </button>
        )}
      </div>
      {subTree.size > 0 && (
        <ul className="secondary-navigation__item__dropdown">
          {subTree.map((item2: ImmutableEntity<any>) => {
            const title2 = item2.getIn(['link', 'title'], 'Untitled');
            const url2 = item2.getIn(['link', 'url'], '');
            return (
              <li key={title2}>
                <CoreLink
                  to={url2}
                  className="NavigationMainMenuDesktop--subMenu__items__title overlapping-link"
                >
                  <span>{title2} <div className="icon icon-chevron-right" /></span>
                </CoreLink>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

interface NavigationSecondaryMenuProps {
  items: [ImmutableEntity<any>],
}

const NavigationSecondaryMenu: React.FC<NavigationSecondaryMenuProps> = ({ items }) => (
  <ul className="secondary-navigation__items">
    {items.map((item) => (
      <NavigationSecondaryMenuItem item={item} />
    ))}
  </ul>
);

export default NavigationSecondaryMenu;
